import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import state from './sendSubOrderToConfirm.state';
import getters from './sendSubOrderToConfirm.getters';
import actions from './sendSubOrderToConfirm.actions';
import mutations from './sendSubOrderToConfirm.mutations';

const namespace = 'sendSubOrderToConfirm';

BaseStore.registerModule(namespace, {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
});

export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers(namespace);

export {
	mapState,
	mapGetters,
	mapActions,
	mapMutations
};